import { ActionTypes, State, SaasIntegrationAction } from "./types";

const initialState: State = {
  pages: [],
  firstTimeToken: null,
  tokenExpiry: null,
  loading: false,
  error: null,
};

const ACTION_HANDLERS = {
  [ActionTypes.SET_SAAS_PAGES]: (state: State, action: any) => ({
    ...state,
    pages: action.pages,
  }),
  [ActionTypes.SET_FIRST_TIME_TOKEN]: (state: State, action: any) => ({
    ...state,
    firstTimeToken: action.token,
    tokenExpiry: action.expiry,
  }),
  [ActionTypes.SET_LOADING]: (state: State, action: any) => ({
    ...state,
    loading: action.loading,
  }),
  [ActionTypes.SET_ERROR]: (state: State, action: any) => ({
    ...state,
    error: action.error,
  }),
  [ActionTypes.CLEAR_TOKEN]: (state: State) => ({
    ...state,
    firstTimeToken: null,
    tokenExpiry: null,
  }),
};

export default function saasIntegrationReducer(
  state: State = initialState,
  action: SaasIntegrationAction
): State {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
